module.exports = __webpack_public_path__ + "fonts/GT-America-Regular.489e7dd0.woff";